import Count          from "../../fundamentals/count/Count";
import Pagination     from "../../fundamentals/pagination/Pagination";
import CustomerRecord from "./CustomerRecord";

class CustomerRecords {
  constructor(
    private readonly _list: CustomerRecord[] = [],
    private readonly _pagination: Pagination = new Pagination(),
    private readonly _count: Count = new Count(),
  ) {}

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): CustomerRecord[] {
    return this._list;
  }

  get pagination() {
    return this._pagination;
  }

  get count() {
    return this._count;
  }
}

export default CustomerRecords;
